import { createSlice } from "@reduxjs/toolkit";

/**
 * Držimo konkurentne betove (više loptica u vazduhu).
 * Za svaki ticketId pamtimo:
 *  - hasAck: stigao bet_ack sa socketa
 *  - hasBallDone: lopta pala u canvasu
 *  - winAmount: iz bet_ack-a (primenjuje se tek kada lopta padne)
 *  - meta: opcione info (bet, wsId, serverBalanceAtAck...)
 */
const initialState = {
  byId: {},       // { [ticketId]: { ticketId, hasAck, hasBallDone, winAmount, meta } }
  order: [],      // niz ticketId-ova (korisno za debug)
  lastAckTick: 0, // bumpujemo na svaki ACK kako bi UI (GreenButton) mogao da otključa
};

const pendingBetsSlice = createSlice({
  name: "pendingBets",
  initialState,
  reducers: {
    upsertFromAck(state, { payload }) {
      const { ticketId, winAmount, meta } = payload;
      const item = state.byId[ticketId] || {
        ticketId,
        hasAck: false,
        hasBallDone: false,
        winAmount: null,
        meta: {},
      };
      item.hasAck = true;
      item.winAmount = winAmount;
      item.meta = { ...item.meta, ...meta };
      state.byId[ticketId] = item;

      if (!state.order.includes(ticketId)) state.order.push(ticketId);
      state.lastAckTick += 1; // signal za unlock
    },

    markBallDone(state, { payload }) {
      const { ticketId } = payload;
      const item = state.byId[ticketId] || {
        ticketId,
        hasAck: false,
        hasBallDone: false,
        winAmount: null,
        meta: {},
      };
      item.hasBallDone = true;
      state.byId[ticketId] = item;
      if (!state.order.includes(ticketId)) state.order.push(ticketId);
    },

    remove(state, { payload }) {
      const { ticketId } = payload;
      if (state.byId[ticketId]) delete state.byId[ticketId];
      state.order = state.order.filter((id) => id !== ticketId);
    },

    clearAll() {
      return initialState;
    },
  },
});

export const { upsertFromAck, markBallDone, remove, clearAll } = pendingBetsSlice.actions;
export default pendingBetsSlice.reducer;
